import React from 'react';

import Header from 'Components/Header/Header'
import ShirtForm from 'Components/Shirt/ShirtContainer';
import PaymentForm from 'Components/Payment/PaymentContainer';
import ShippingForm from 'Components/Shipping/ShippingContainer';
import ReviewAndSubmit from 'Components/Review_and_Submit/Review_and_SubmitContainer';
import Pay from 'Components/Pay/PayContainer';
import dataAPI from 'Utilities/dataAPI';

import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './Form.css';
// import classes from '*.module.scss';     //dont know where this came from

import { styles, steps, SHIRT_STEP, PAYMENT_INFO_STEP, SHIPPING_INFO_STEP } from 'Utilities/Constants/Form_Constants';

class Form extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hideStepperLabel: false,
        }
    }

    notifyAddItemToCart = () => {
        toast.info('Added order to cart!', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
        });
    }

    notifyNeedToAddItem = () => {
        toast.error('Need to add an item to cart first!', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
        });
    }

    getStepContent = (step) => {
        if (!this.props.startForm) return null;
        switch (step) {
            case 0:
                return <ShirtForm showErrors={this.props.nextAttempted} />;
            case 1:
                return <PaymentForm showErrors={this.props.nextAttempted} />;
            case 2:
                return <ShippingForm showErrors={this.props.nextAttempted} />;
            case 3:
                return <ReviewAndSubmit />;
            default:
                throw new Error('Unknown step');
        }
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();


        //handle locations api request here
        //put check so it only does it once
        if (this.props.shippingLocations.length === 0) {
            this.getLocations();
        }
        //handle concession info api request here
        //put check so it only does it once
        if (this.props.concessionInfo.length === 0) {
            this.getConcessionData();
        }

    }

    getLocations = async () => {
        try {
            let facilityResult = await dataAPI.getLocations();

            let facilities = facilityResult.result
                .map(
                    facility => {
                        return { location_id: facility.locationId, location_name: facility.displayName }
                    }
                )
            this.props.setShippingLocations(facilities);
        }
        catch (error) {
            console.error(error);
        }
    }

    getConcessionData = async () => {
        try {
            let concessionResult = await dataAPI.getConcessionInfo();
            this.props.setConcessionInfo(concessionResult.result.response);
            this.props.setStartForm();
        }
        catch (error) {
            console.error(error);
        }
    }

    handleResize = () => {
        let do_hide = false;
        if (window.innerWidth <= 760) {
            do_hide = true;
        } else {
            do_hide = false;
        }

        this.setState({ hideStepperLabel: do_hide })
    }

    handleNext = () => {
        if (this.props.step <= 2) {
            if (this.checkValids()) {
                this.props.setAttempted(false);
                //check if on payment step -> review (ie in-store purchase)
                if (this.props.paymentDetails.deliveryOption === "inStore" && this.props.step === 1) {
                    this.props.clearShippingInfo();     //clear shipping info if delivering to location
                    this.props.setStep(this.props.step + 2);
                } else {
                    this.props.setStep(this.props.step + 1);

                }
            } else {
                this.props.setAttempted(true);
            }
        } else {
            this.props.setStep(this.props.step + 1);
        }
        this.forceUpdate();
    }

    handleBack = () => {
        //case where shipping instore and going back
        if (this.props.paymentDetails.deliveryOption === "inStore" && this.props.step === 3) {
            this.props.setStep(this.props.step - 2);
        } else {
            this.props.setStep(this.props.step - 1);
        }
        this.forceUpdate();
    }

    disableNextButton = () => {
        if(this.props.step === SHIRT_STEP) {
            const shirtValids = this.props.valids.shirt;
            if (
                shirtValids.type
                && shirtValids.size
                && shirtValids.colour
                && shirtValids.quantity
                && this.props.order.length > 0
            ) return "";
            else return "invalid-cart"
        }

        return ""
    }

    checkValids = () => {
        //check all valids' fields for the [step] index of valids
        let isValid = true;

        switch (this.props.step) {
            case SHIRT_STEP:
                const shirtValids = this.props.valids.shirt;
                isValid = (
                    shirtValids.type
                    && shirtValids.size
                    && shirtValids.colour
                    && shirtValids.quantity
                    && this.props.order.length > 0
                );
                //check if everything else is valid except cart, send out appropriate toast based on that
                if (
                    shirtValids.type
                    && shirtValids.size
                    && shirtValids.colour
                    && shirtValids.quantity
                    && !(this.props.order.length > 0)
                ) this.notifyNeedToAddItem();
                break;

            case PAYMENT_INFO_STEP:
                const paymentValids = this.props.valids.payment;
                isValid = (
                    paymentValids.firstName
                    && paymentValids.lastName
                    && paymentValids.email
                    && paymentValids.phone
                    && paymentValids.location
                );
                break;

            case SHIPPING_INFO_STEP:
                const shippingValids = this.props.valids.shipping;
                isValid = (
                    shippingValids.country
                    && shippingValids.provinceState
                    && shippingValids.city
                    && shippingValids.address
                    && shippingValids.postalCode
                );
                break;
            default: 
                break;
        }

        return isValid;
    }

    handleAddToCart = () => {
        //shouldn't need to check fields here, they would have alredy been checked
        const shirtInfo = this.props.shirtDetails;
        let currentOrder = this.props.order;
        let cartObj = {
            fit: shirtInfo.type,
            size: shirtInfo.size,
            colour: shirtInfo.colour,
            quantity: shirtInfo.quantity
        }
        //need to check if item already exists
        if (this.orderItemAlreadyExists(cartObj)) {
            //if identical item already exists in list
            //find the item in the list, ADD to its quantity and proceed
            let currentOrder = this.props.order;
            currentOrder.forEach(orderItem => {
                if (orderItem.fit === cartObj.fit
                    && orderItem.size === cartObj.size
                    && orderItem.colour === cartObj.colour) {
                        //append to this order item's quantity
                        orderItem.quantity += cartObj.quantity;
                }
            })
            //update list rather than push
            this.props.updateOrder(currentOrder)
        } else {
            //add as new item index
            currentOrder.push(cartObj);
        }

        this.notifyAddItemToCart();
        this.forceUpdate();
    }

    orderItemAlreadyExists = (cartObj) => {
        //return true if there's an item with same size, gender and colour on list
        return this.props.order.some(orderItem =>
            orderItem.fit === cartObj.fit
            && orderItem.size === cartObj.size
            && orderItem.colour === cartObj.colour)
    }

    cartValid = () => {
        const shirtValids = this.props.valids.shirt;
        if (
            shirtValids.type
            && shirtValids.size
            && shirtValids.colour
            && shirtValids.quantity
        ) return "";
        else return "invalid-cart"
    }

    render() {
        const { classes } = this.props;

        let hideStepperLabel = false;
        if (window.innerWidth <= 760) {
            hideStepperLabel = true;
        }

        return (

            <div className="form-container">
                <React.Fragment>
                    <CssBaseline />
                    <main className={classes.layout}>


                        <Paper className={classes.paper}>
                            {/* Title of Form */}
                            <Header />

                            {/* Top level progress bar */}
                            <Stepper activeStep={this.props.step} className={classes.stepper}>
                                {steps.map(label => (
                                    <Step key={label}>
                                        {/* <StepLabel>{this.state.hideStepText ? "" : label}</StepLabel> */}
                                        <StepLabel>{hideStepperLabel ? "" : label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>


                            <React.Fragment>
                                {/* Form scene containing inputs for a specific section */}
                                {this.getStepContent(this.props.step)}

                                <div className={classes.buttons}>
                                    {this.props.step === 0 && (
                                        <div className={"button-flex " + this.cartValid()}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.handleAddToCart}
                                                className={classes.button}
                                            >
                                                {'Add to Cart'}
                                            </Button>
                                        </div>
                                    )}

                                    {this.props.step !== 0 && (
                                        <div className="button-flex">

                                            <Button
                                                onClick={this.handleBack}
                                                className={classes.button}>
                                                Back
                                        </Button>
                                        </div>
                                    )}

                                    {/* {this.props.step === steps.length - 1 ? ( */}
                                    {this.props.step === 3 ? (
                                        <div className="button-flex">
                                            <Pay
                                            // dbSubmit={this.dbSubmit}
                                            // recaptcha={this.state.recaptcha}
                                            // paymentDetails={this.state.paymentDetails}
                                            // concessionInfo={this.state.concessionInfo} 
                                            />
                                        </div>
                                    ) : (
                                        <div className={"button-flex " + this.disableNextButton()}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.handleNext}
                                                className={classes.button}
                                            >
                                                {'Next'}
                                            </Button>
                                        </div>
                                        )}
                                </div>
                            </React.Fragment>
                        </Paper>
                    </main>
                </React.Fragment>

                <ToastContainer
                    position="top-right"
                    autoClose={4000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />

            </div>

        )

    }
}

Form.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Form);